export default "__VITE_ASSET__8KuDPLWUBS$tjbh3S0gi6A__"